export function formatIncomingAccount(externalAccounts, internalAccounts) {
  let obj = {}

  // Group accounts by external id
  for (const contract of externalAccounts) {
    let internalAccount = internalAccounts.find(
      account => account.connexionId === contract.idConnection
    )

    if (internalAccount && !contract.deleted) {
      const matchingContract = internalAccount.portfolios.find(portfolio => parseInt(portfolio.externalId) === parseInt(contract.id))

      // Init account
      if (!obj[contract.idConnection]) {
        obj[contract.idConnection] = {
          bank: internalAccount.bank,
          id: internalAccount.id,
          connexionId: contract.idConnection,
          portfolios: [],
          state: internalAccount.state,
          error: internalAccount.error
        }
      }
      // Structure incoming portfolio
      const portfolio = formatIncomingContract(contract, matchingContract ? matchingContract.id : null)

      obj[contract.idConnection].portfolios.push(portfolio)
    }
  }

  // Strip object names from array
  // So we conform with our own API data structure
  return Object.keys(obj).map(key => obj[key])
}

export function formatIncomingContract(contract, internalPortfolioId) {
  return {
    amount: contract.balance,
    currency: contract.currency ? contract.currency.name : '',
    currencySymbol: contract.currency ? contract.currency.symbol : '',
    disabled: contract.disabled,
    demo: false,
    externalId: contract.id,
    id: internalPortfolioId,
    kind: contract.type,
    name: contract.name
  }
}

export function webauthUrl({ idConnector, token, idConnection, source }) {
  if (idConnector) {
    return `${process.env.BIAPI_HOST}2.0/webauth?id_connector=${idConnector}&client_id=${process.env.BIAPI_CLIENT_ID}&token=${token}&redirect_uri=${process.env.BIAPI_REDICTION_URI}`
  } else if (idConnection) {
    return `${process.env.BIAPI_HOST}2.0/webauth?id_connection=${idConnection}&client_id=${process.env.BIAPI_CLIENT_ID}&token=${token}&redirect_uri=${process.env.BIAPI_REDICTION_URI}`
  }
}
